import { _objectKeys } from '@naturalcycles/js-lib'
import { BirthControlMethod, MenopausalHormoneTherapy } from '@naturalcycles/shared'

class PerimenopauseUtil {
  public getSegment(
    birthControlMethod?: BirthControlMethod,
    menopausalHormoneTherapy?: MenopausalHormoneTherapy,
  ): PerimenopauseSegment {
    if (categoryByBirthControl[birthControlMethod!] === BirthControlMethodCategory.HORMONAL) {
      return PerimenopauseSegment.SYMPTOMS
    }

    if (
      _objectKeys(menopausalHormoneTherapy || {}).length ||
      categoryByBirthControl[birthControlMethod!] === BirthControlMethodCategory.PERMANENT
    ) {
      return PerimenopauseSegment.CYCLE
    }

    return PerimenopauseSegment.BIRTH_CONTROL
  }
}

export const perimenopauseUtil = new PerimenopauseUtil()

export enum PerimenopauseSegment {
  SYMPTOMS = 1,
  CYCLE = 2,
  BIRTH_CONTROL = 3,
}

enum BirthControlMethodCategory {
  HORMONAL = 1,
  PERMANENT = 2,
  NON_HORMONAL = 3,
}

const categoryByBirthControl: Record<BirthControlMethod, BirthControlMethodCategory> = {
  [BirthControlMethod.NONE]: BirthControlMethodCategory.NON_HORMONAL,
  [BirthControlMethod.OTHER]: BirthControlMethodCategory.NON_HORMONAL,
  [BirthControlMethod.PILL]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.CONDOM]: BirthControlMethodCategory.NON_HORMONAL,
  [BirthControlMethod.SHOT]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.NUVA_RING]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.IMPLANT]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.HORMONAL_UID]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.PULL_OUT]: BirthControlMethodCategory.NON_HORMONAL,
  [BirthControlMethod.COPPER_IUD]: BirthControlMethodCategory.PERMANENT,
  [BirthControlMethod.PATCH]: BirthControlMethodCategory.HORMONAL,
  [BirthControlMethod.VASECTOMY]: BirthControlMethodCategory.PERMANENT,
  [BirthControlMethod.FEMALE_STERILISATION]: BirthControlMethodCategory.PERMANENT,
}
